import { useMutation } from '@tanstack/react-query'
import { updateChallenge } from '../../../service/challenge'

function useUpdateChallenge() {
  return useMutation({
    mutationKey: ['update-challenge'],
    mutationFn: updateChallenge,
  })
}

export default useUpdateChallenge
